// extracted by mini-css-extract-plugin
module.exports = {"container":"_1410bfd27b--container--vZhp6","link-area":"_1410bfd27b--link-area--jbRPA","logo":"_1410bfd27b--logo--qGlwa","content":"_1410bfd27b--content--JOD3X"};